import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { config = {} }) {
    const { data, meta } = get(await this.$axios.get(routes.creditcardtokens.list(), config), 'data')

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'tranzzo',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  },
  async create({ commit }, { payload = {}, config = {} }) {
    const data = get(await this.$axios.post(routes.creditcardtokens.list(), payload, config), 'data')
    commit(
      'AFTER_CREATE',
      {
        namespace: 'tranzzo',
        item: data
      },
      { root: true }
    )
    return data
  },
  async delete({ commit }, id) {
    const response = await this.$axios.delete(routes.creditcardtokens.concrete(id))
    commit('AFTER_DELETE', { namespace: 'tranzzo', id }, { root: true })
    return response
  }
}
